// extracted by mini-css-extract-plugin
module.exports = {"Box":"CustomFadeBox_Box__3K42z","Div":"CustomFadeBox_Div__11M1J","LargeDiv":"CustomFadeBox_LargeDiv__1iw1v"};